import CaptionsChildView from './CaptionsChildView';

export default CaptionsChildView;
